import { useTranslation } from "react-i18next"

export default function BreakdownItem({title, amount, dataTestId}) {
  const { t } = useTranslation()

  return(
    <>
      <p className="pl-1">{title}</p>
      <p className="text-right" data-testid={dataTestId}>{amount}</p>
    </>
  )
}